import React, { useMemo } from 'react';
import styles from './index.module.scss';
import { useAllOffers } from '../../api/api.calls';
import Fallbackimage from '../../assets/global/Fallbackimage.svg';
import { get } from 'lodash';
import CustomImg from '../CustomImg';
import { useNavigateRoute } from '../../hooks/custom.hooks';

function TopBrandRow() {
  const { data: apiResponse } = useAllOffers();
  const allBrands = useMemo(
    () => get(apiResponse, 'filters', {}),
    [apiResponse],
  );
  const topBrand = allBrands?.brand?.preferred_brands || [];
  const navigateRoute = useNavigateRoute();

  return (
    <>
      {topBrand?.length > 0 && (
        <div className={styles.topBrandRow}>
          <div className={styles.headerRow}>
            <div className={styles.sectionName}>EXPLORE TOP BRANDS</div>
            <div
              onClick={() =>
                navigateRoute({
                  nextPage: `/brands`,
                })
              }
            >
              <div className={styles.viewAllBtn}>View All</div>
            </div>
          </div>
          <div className={styles.topBrandList}>
            {topBrand.map((brand, brandIndex) => {
              return (
                <div
                  key={brandIndex}
                  className={styles.categoryItem}
                  onClick={() =>
                    navigateRoute({
                      nextPage: `/offers/?brand=${brand?.merchant_id}`,
                    })
                  }
                >
                  <div className={styles.brandItemContainer}>
                    <CustomImg
                      loading="lazy"
                      fallbackSrc={Fallbackimage}
                      src={brand.merchant_logo}
                      alt={brand.merchant_name}
                      className={styles.brandLogo}
                    />
                    <div>{brand.merchant_name}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(TopBrandRow);
